import CurrencyDisplay from 'services/CurrencyDisplay/CurrencyDisplay';

/**
 * Adds the currency symbol and selects the current currency
 *
 * Looks for: ::Currency::{USD=25|EUR=25|GBP=20|HKD=200}
 * Returns: £20
 */
export const currencyHandler = (
  text: string,
  currentCurrency: undefined | string,
  trigger: string = '::Currency::'
) => {
  const regex = /{([^}]+)}/g;
  const matches = text.match(regex);
  if (!matches) text;

  let newText = text;
  matches?.map(match => {
    const keyValuePairs = match.substring(1, match.length - 1).split('|');
    keyValuePairs.forEach(pair => {
      const [key, value] = pair.split('=');
      if (key === currentCurrency) {
        newText = newText.replace(
          trigger + match,
          CurrencyDisplay({
            currency: key,
            value: parseInt(value),
          })
        );
      }
    });
  });

  return newText;
};
